import { useState } from "react";
import "./gallery.css";

const Gallery = ({ images }) => {
	const [selectedIndex, setSelectedIndex] = useState(null);

	if (!images || images.length === 0) return null;

	const openLightbox = (index) => setSelectedIndex(index);
	const closeLightbox = () => setSelectedIndex(null);

	const goToPrev = (e) => {
		e.stopPropagation();
		setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
	};

	const goToNext = (e) => {
		e.stopPropagation();
		setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
	};

	return (
		<div className="gallery-section">
			<h2 className="gallery-section-title">
				<span className="gallery-icon">
					<svg width="26" height="26" viewBox="0 0 16 16" fill="currentColor">
						<path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
						<path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10zM14 2H2a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094L14 9.5V3a1 1 0 0 0-1-1z"/>
					</svg>
				</span>
				Galerie photos
			</h2>

			<div className="gallery-grid">
				{images.map((image, index) => (
					<div
						className="gallery-item"
						key={index}
						onClick={() => openLightbox(index)}
					>
						<img
							src={image.img}
							alt={image.alt || `Photo ${index + 1}`}
							loading="lazy"
						/>
						<div className="gallery-item-overlay">
							<svg width="24" height="24" viewBox="0 0 16 16" fill="white">
								<path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
								<path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
							</svg>
						</div>
					</div>
				))}
			</div>

			{/* Lightbox */}
			{selectedIndex !== null && (
				<div className="lightbox" onClick={closeLightbox}>
					<button className="lightbox-close" onClick={closeLightbox}>
						<svg width="28" height="28" viewBox="0 0 16 16" fill="white">
							<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854z"/>
						</svg>
					</button>

					{images.length > 1 && (
						<>
							<button className="lightbox-nav lightbox-prev" onClick={goToPrev}>
								<svg width="32" height="32" viewBox="0 0 16 16" fill="white">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
								</svg>
							</button>
							<button className="lightbox-nav lightbox-next" onClick={goToNext}>
								<svg width="32" height="32" viewBox="0 0 16 16" fill="white">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
								</svg>
							</button>
						</>
					)}

					<div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
						<img
							src={images[selectedIndex].img}
							alt={images[selectedIndex].alt || ""}
						/>
						{images[selectedIndex].title && (
							<p className="lightbox-caption">
								{images[selectedIndex].title}
							</p>
						)}
						<p className="lightbox-counter">
							{selectedIndex + 1} / {images.length}
						</p>
					</div>
				</div>
			)}
		</div>
	);
};

export default Gallery;
